import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import { IAssembleiaAssociadoPauta, IAssembleiaAssociadoPautaOpcao } from "./../store/modules/AssembleiasAssociadoReducer";
import { IAssembleiasAssessorPauta, IAssembleiasAssessorItens } from "store/modules/AssembleiasAssessorReducer";
import { Dispatch } from 'redux';
import { getCurrentWSEvent, setCurrentWSEvent, wsAssembleiasActionsClose, wsAssembleiasActionsOpen } from 'store/modules/WSAssembleiasActions';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { isAssessorProfile } from './AuthUtils';

const wsStart = (usuario: IAuthUserReducer, eventoId: number, dispatch: Dispatch<any>): Promise<any> => {
  const token: string = isAssessorProfile(usuario!.perfil) ? usuario!.ladpAccessToken! : usuario!.associadoAccessToken!;
  return new Promise((resolve, reject) => {
    setCurrentWSEvent(eventoId);
    dispatch(
      wsAssembleiasActionsOpen(
        token,
        usuario!.cpfCnpj,
        eventoId,
        () => {
          resolve(undefined);
        },
        () => reject()
      )
    )
  })
}

const wsStop = (eventoId: number, dispatch: Dispatch<any>): Promise<any> => {
  return new Promise((resolve) => {
    dispatch(wsAssembleiasActionsClose());
    setCurrentWSEvent(-1);
    resolve(undefined);
  })
}

export const wsStartStop = (usuario: IAuthUserReducer, eventoId: number, dispatch: Dispatch<any>, wsOpened?: boolean) => {
  const currWSEvent: number | null = getCurrentWSEvent();
  if (wsOpened) {
    if (currWSEvent !== eventoId) {
      wsStop(eventoId, dispatch);
    }
  } else {
    wsStart(usuario, eventoId, dispatch)
  }
}

export const getContaIdentificador = (conta: AssembleiaContaAssociado): string => {
  return conta.codigoAgencia + '|' +
    conta.codigoCooperativa + '|' +
    conta.cpfCnpj + '|' +
    conta.cpfRepresentanteLegal + '|' +
    conta.idAssociado.toString() + '|' +
    conta.idConvocado.toString() + '|' +
    conta.nomeAssociado + '|' +
    conta.numeroConta + '|' +
    conta.numeroNucleo;
}

export const contaDisponivelParaSelecao = (conta: AssembleiaContaAssociado, cpfCnpjAssociado: string): boolean => {
  // alguém já está presente com essa conta
  return conta.presente === false;
}

export const getContasDisponiveisParaSelecao = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): AssembleiaContaAssociado[] => {
  return contas.filter(
    (conta: AssembleiaContaAssociado): boolean => {
      return contaDisponivelParaSelecao(conta, cpfCnpjAssociado);
    }
  )
}

export const getTotalContasDisponiveisParaSelecao = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): number => {
  return getContasDisponiveisParaSelecao(contas, cpfCnpjAssociado).length;
}

export const contaSelecionadaPeloUsuario = (conta: AssembleiaContaAssociado, cpfCnpjAssociado: string): boolean => {
  // alguém já está presente e a conta atual é o representante legal desse convocado
  // alguém já está presente e a conta atual é o próprio convocado
  return (conta.presente === true && conta.cpfRepresentanteConfirmado === cpfCnpjAssociado) ||
    (conta.presente === true && conta.cpfCnpj === cpfCnpjAssociado);
}

export const getContasSelecionadasPeloUsuario = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): AssembleiaContaAssociado[] => {
  return contas.filter(
    (conta: AssembleiaContaAssociado): boolean => {
      return contaSelecionadaPeloUsuario(conta, cpfCnpjAssociado);
    }
  )
}

export const getTotalContasSelecionadasPeloUsuario = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): number => {
  return getContasSelecionadasPeloUsuario(contas, cpfCnpjAssociado).length
}

export const getPermitirVoto = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): boolean => {
  const contasSelecionadas = getContasSelecionadasPeloUsuario(contas, cpfCnpjAssociado);
  const contasColaborador = contasSelecionadas.filter(
    (conta: AssembleiaContaAssociado): boolean => {
      return conta.restricao !== null;
    }
  );
  return contasSelecionadas.length === contasColaborador.length ? false : true
}

export const contaSelecionadaOuNaoPeloUsuario = (conta: AssembleiaContaAssociado, cpfCnpjAssociado: string): boolean => {
  // alguém já está presente com essa conta
  return conta.presente === false ||
    contaSelecionadaPeloUsuario(conta, cpfCnpjAssociado);
}

export const getContasSelecionadasOuNaoPeloUsuario = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): AssembleiaContaAssociado[] => {
  return contas.filter(
    (conta: AssembleiaContaAssociado): boolean => {
      return contaSelecionadaOuNaoPeloUsuario(conta, cpfCnpjAssociado);
    }
  )
}

export const getTotalContasSelecionadasOuNaoPeloUsuario = (contas: AssembleiaContaAssociado[], cpfCnpjAssociado: string): number => {
  return getContasSelecionadasOuNaoPeloUsuario(contas, cpfCnpjAssociado).length
}

export const getContasSemContaUsuario = (contas: AssembleiaContaAssociado[], cpfCnpj: string): AssembleiaContaAssociado[] => {
  return contas.filter((conta: AssembleiaContaAssociado): boolean => {
    return conta.cpfCnpj !== cpfCnpj;
  })
}

export const pautaValida = (pauta: IAssembleiaAssociadoPauta): boolean => {
  // Pode haver pauta sem itens, segundo a Gabriele
  // if (!pauta.itens || pauta.itens.length === 0) {
  //   return false;
  // }
  // deixarei 5min default caso não venha
  // if (!pauta.tempoVotacao) {
  //   return false;
  // }
  return true;
}

export const getPautaAssociadoWithOrderedOptions = (pauta: IAssembleiaAssociadoPauta): IAssembleiaAssociadoPauta => {
  return {
    ...pauta,
    itens: pauta.itens.map(
      (item: IAssembleiaAssociadoPautaOpcao, index: number): IAssembleiaAssociadoPautaOpcao => {
        return {
          ...item,
          ordem: item.flgAbstencao ? pauta.itens.length : index
        }
      }
    )
  }
}

export const getPautaAssessorWithOrderedOptions = (pauta: IAssembleiasAssessorPauta): IAssembleiasAssessorPauta => {
  return {
    ...pauta,
    itens: pauta.itens.map(
      (item: IAssembleiasAssessorItens, index: number): IAssembleiasAssessorItens => {
        return {
          ...item,
          ordem: item.flgAbstencao ? pauta.itens.length : index
        }
      }
    )
  }
}

// export const getPautasWithOrderedOptions = (pautas: IAssembleiaAssociadoPauta[] | IAssembleiasAssessorPauta[]): IAssembleiaAssociadoPauta[] | IAssembleiasAssessorPauta[] => {
//   return pautas.map(
//     (pauta) => {
//       return pauta;
//     }
//   );


//   return pautas.map(
//     (pauta: IAssembleiaAssociadoPauta | IAssembleiasAssessorPauta): IAssembleiaAssociadoPauta | IAssembleiasAssessorPauta => {
//       return getPautaWithOrderedOptions(pauta);
//     }
//   )
// }